import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { IdentityConfigurationService } from '@identity/identity-configuration.service';
import { IdentityUserService } from '@identity/identity-user.service';

const RESTRICTED_MODULES_CODES: ReadonlyArray<string> = ['LC'];
const RESTRICTED_USER_PROFILES: ReadonlyArray<string> = ['PUBLIC_VERIFIED_ADMIN', 'PUBLIC_VERIFIED', 'PUBLIC'];

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private readonly _isLandpageHidden = signal(false);
    readonly isLandpageHidden = this._isLandpageHidden.asReadonly();

    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);
    private readonly identityUserService = inject(IdentityUserService);
    private readonly identityConfigService = inject(IdentityConfigurationService);

    constructor() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {
            this.evaluateLandpageVisibility();
        });
    }

    private evaluateLandpageVisibility() {
        const storedModuleCode = this.identityConfigService.getService();

        if (!RESTRICTED_MODULES_CODES.includes(storedModuleCode)) {
            this.setLandpageHidden(false);
            return;
        }

        const currentUser = this.identityUserService.getUser();

        if (!currentUser || Object.keys(currentUser).length === 0) {
            this.setLandpageHidden(true);
            return;
        }

        const product = this.identityConfigService.getProduct();
        const hasProfileRestricted = currentUser.clients.some(
            (client: any) => RESTRICTED_USER_PROFILES.includes(client.profile) && client.product === product
        );

        this.setLandpageHidden(hasProfileRestricted);
    }

    private setLandpageHidden(hidden: boolean) {
        this._isLandpageHidden.set(hidden);
    }
}
